import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

const baseStyles = {
    container: {
        overflow: 'visible',
        paddingBottom: Theme.primaryPaddingBottom,
        paddingHorizontal: Theme.primaryMargin
    },
    carousel: {
        marginTop: 20,
        marginEnd: -Theme.primaryMargin,
        marginRight: -Theme.primaryMargin
    },
    promoCarousel: {
        marginBottom: 20
    },
    viewAllContainer: {
        flex: 1
    }
};

if (Device.isWeb) {
    baseStyles.viewAllContainer = {
        width: 1280,
        alignSelf: 'center',
        paddingTop: 40,
        flex: 1
    };
    baseStyles.carousel.marginEnd = 0;
    baseStyles.carousel.marginRight = 0;
}

if (Device.isTabletOrWeb) {
    baseStyles.tvGuideButton = {
        alignSelf: 'flex-end'
    };
}

export default StyleSheet.create(baseStyles);
